import { Link } from "react-router-dom";
const jotrLogo = "/logo/seatrcblack.svg";

export const Footer = () => {
  return (
    <>
      {/* Footer Utama – Background gradient red to black from bottom to top */}
      <div className="bg-gray-100">
        <div className="footer sm:footer-horizontal text-gray-700 p-8 py-10 max-w-7xl mx-auto flex flex-col md:flex-row md:justify-between items-center gap-10">
          {/* Kiri – Deskripsi Event */}
          <aside className="md:w-2/3 space-y-6">

            <div>
              <p className="text-lg font-black">
                Southeast Asian Trail Running Cup
              </p>

              <p className="lg:max-w-4xl">
                The Southeast Asian Trail Running Cup (SEATRC) is now proudly
                hosted in Indonesia, taking place on the iconic and challenging
                trails of Mount Gede Pangrango National Park.
              </p>

              <p className="lg:max-w-4xl">
                This regional championship unites top trail runners from across
                Southeast Asia, featuring competitive race categories from short
                trail formats to ultra-endurance distances.
              </p>
            </div>
          </aside>

          {/* Kanan – Logo Event */}
          <div className="flex flex-row flex-wrap justify-center md:justify-end gap-8 items-center">
            <Link to="/" className="flex items-center">
              <img src={jotrLogo} alt="Event Logo" className="w-28 md:w-32" />
            </Link>
          </div>
        </div>
      </div>

      {/* Footer Bawah – Copyright */}
      <footer className="footer footer-center bg-gray-200 text-base-content p-4">
        <aside>
          <p className="text-sm md:text-base text-gray-700">
            Copyright © 2026 - All rights reserved
            <span className="font-semibold">
              {" "}
              PT. Cakrawala Jakarta Kreatif
            </span>
          </p>
        </aside>
      </footer>
    </>
  );
};
